import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { LoadingAnimation } from "../../../../components/Loading/LoadingAnimation";
import { handleSaveFirstTimeNudge } from "../../../../helper";
import { createFirstTimePersonaState } from "../../../../helper/customizedNudge/FirstTImePersonaNudge/FirstTimePersonaNudge";
import DraggableNudge from "../../DraggableNudge";
import PreviewNudge from "../../PreviewNudge";
import ExcludeReferrerSites from "./ExludeReferrerSites/ExcludeReferrerSites";
import NudgeFields from "./NudgeFields";
import NudgeFieldsURL from "./NudgeFieldsURL";
import NudgeOptions from "./NudgeOptions";
import PersonaNudgeTitle from "./PersonaNudgeTitle";
import ReferrerSites from "./ReferrerSites/ReferrerSites";
import ToggleSwitch from "./ToggleSwitch";
import UrlQueryParams from "./UrlQueryParams/UrlQueryParams";

const FirstTimePersonaNudge = ({
  nudgeData,
  nudgeId,
  isLoading,
  user,
  nudgeText,
  userPersonas,
  setUserPersonas,
  userPersonaKey,
  handleSaveUserPersonas
}) => {
  const activeButton = useRef(null);
  const [nudgeFields, setNudgeFields] = useState({});
  const [customizeState, setCustomizeState] = useState({});
  const [nudgePosition, setNudgePosition] = useState({
    desktop: { top: 0, left: 0 },
    mobile: { top: 0 },
  });
  const [nudgeMode, setNudgeMode] = useState("desktop");

  const globalNudgeData = useSelector((state) => state.nudge.globalNudgeData) || {};

  const globalFields = globalNudgeData["firstTimePersonaNudge"]

  // console.log("global fields from first time persona nudge", globalNudgeData)

  // console.log("Nudge Data", nudgeData)


  useEffect(() => {
    activeButton.current = nudgeData.nudgeOfferText.optionValue;
    setNudgeFields(nudgeData.nudgeOfferText);
    const state = createFirstTimePersonaState(nudgeData);
    setCustomizeState(state);
    console.log("state", state)
    setNudgePosition({
      desktop: {
        top: nudgeData.nudge.nudgePosition.desktop.top,
        left: nudgeData.nudge.nudgePosition.desktop.left,
      },
      mobile: { top: nudgeData.nudge.nudgePosition.mobile.top },
    });
  }, [nudgeData]);



  const handleNudgeOptionClick = (option) => {
    setNudgeFields(option);
    activeButton.current = option.optionValue;
  };

  return (
    <div className="persona__nudge border border-neutral-600 dark:border-neutral-800 rounded shadow-lg shadow-blue-800 w-full p-2 sm:p-4">
      {/* <UserSegment
                  customizeState={customizeState}
                  nudgeData={nudgeData}
      /> */}
      <div className="flex justify-around items-center mb-4">
        <PersonaNudgeTitle
          userPersonas={userPersonas}
          setUserPersonas={setUserPersonas}
          userPersonaKey={userPersonaKey}
        />
        <div className="absolute right-3 flex justify-center items-center">
          <ToggleSwitch
            customizeState={customizeState}
            setCustomizeState={setCustomizeState}
            nudgeData={nudgeData}
          />
          <span className="mx-2">Activate</span>
        </div>
      </div>
      <div className="optionContainer flex flex-col lg:flex-row py-8">
        <NudgeOptions
          nudgeData={nudgeData}
          activeButton={activeButton.current}
          handleNudgeOptionClick={handleNudgeOptionClick}
        />
        {activeButton.current !== "nudgeShowing" ? (
          <NudgeFields
            nudgeFields={nudgeFields}
            globalFields={globalFields[activeButton.current]}
            setNudgeFields={setNudgeFields}
            customizeState={customizeState}
            handleSave={() => {
              handleSaveFirstTimeNudge(
                nudgeData,
                customizeState,
                nudgePosition,
                user,
                nudgeText.optionValue
              )
              handleSaveUserPersonas()
            }}
            setCustomizeState={setCustomizeState}
          />
        ) : (
          <NudgeFieldsURL
            nudgeFields={nudgeFields}
            globalFields={globalFields["nudgeShowing"]}
            setNudgeFields={setNudgeFields}
            customizeState={customizeState}
            nudgeTitle={nudgeText.optionName}
            handleSave={() => {
              handleSaveFirstTimeNudge(
                nudgeData,
                customizeState,
                nudgePosition,
                user,
                nudgeText.optionValue
              )
              handleSaveUserPersonas()
            }
            }
            setCustomizeState={setCustomizeState}
          />
        )}
      </div>
      <ReferrerSites
        referrerSitesData={[]}
        customizeState={customizeState}
        setCustomizeState={setCustomizeState}
        nudgeData={nudgeData}
      />
      <ExcludeReferrerSites
        excludeReferrerSitesData={[]}
        customizeState={customizeState}
        setCustomizeState={setCustomizeState}
        nudgeData={nudgeData}
      />
      <UrlQueryParams
        URLqueryParamData={[]}
        customizeState={customizeState}
        setCustomizeState={setCustomizeState}
        nudgeData={nudgeData}
      />

      <hr className="my-4" />
      <PreviewNudge
        nudgeMode={nudgeMode}
        setNudgeMode={setNudgeMode}
        customizeState={customizeState}
        nudgePosition={nudgePosition}
        userPersonaKey={userPersonaKey}
      />

      {isLoading.loading ? (
        <LoadingAnimation />
      ) : (
        <NudgeArea
          nudgeMode={nudgeMode}
          customizeState={customizeState}
          nudgeId={nudgeId}
          setNudgePosition={setNudgePosition}
          setCustomizeState={setCustomizeState}
        />
      )}
    </div>
  );
};

export default FirstTimePersonaNudge;


export const NudgeArea = ({
  nudgeMode,
  customizeState,
  nudgeId,
  setNudgePosition,
  setCustomizeState,
}) => {
  const draggableDesktopRef = useRef(null);

  useEffect(() => {
    if (draggableDesktopRef.current) {
      let width = draggableDesktopRef.current.offsetWidth;
      draggableDesktopRef.current.height = `${Math.round(
        width / 2.057
      )}px !important`;
    }
  }, []);

  return (
    <>
      {nudgeMode === "desktop" ? (
        <div
          ref={draggableDesktopRef}
          className={`desktop__drag__area m-2 rounded border dark:border-neutral-500 border-neutral-300 relative shadow-md shadow-neutral-500`}
          style={{
            position: "relative",
            overflow: "hidden",
            height: "573px",
          }}
        >
          <DraggableNudge
            key="desktop"
            customizeState={customizeState}
            nudgeId={nudgeId}
            id="desktop"
            setNudgePosition={setNudgePosition}
            setCustomizeState={setCustomizeState}
          />
        </div>
      ) : (
        <div
          className={`mobile__drag__area m-2 rounded border dark:border-neutral-500 border-neutral-300 relative mx-auto shadow-md shadow-neutral-500`}
          style={{
            position: "relative",
            overflow: "hidden",
            minHeight: "844px",
            maxWidth: "340px",
          }}
        >
          <DraggableNudge
            key="mobile"
            customizeState={customizeState}
            nudgeId={nudgeId}
            id="mobile"
            setNudgePosition={setNudgePosition}
            setCustomizeState={setCustomizeState}
          />
        </div>
      )}
    </>
  );
};
